import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import styled from 'styled-components'

import BackgroundImage from 'gatsby-background-image'
// // import background1 from '../images/background1.jpg'
// import background2 from '../images/background2.jpg'

const ContainerElement = ({ className, children }) => (
  <StaticQuery
    query={graphql`
      query {
        desktop1: file(relativePath: { eq: "background1.jpg" }) {
          childImageSharp {
            fluid(quality: 70, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        desktop2: file(relativePath: { eq: "background2.jpg" }) {
          childImageSharp {
            fluid(quality: 70, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        desktop3: file(relativePath: { eq: "background3.jpg" }) {
          childImageSharp {
            fluid(quality: 70, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        desktop4: file(relativePath: { eq: "background4.jpg" }) {
          childImageSharp {
            fluid(quality: 70, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => {
      // Set ImageData.
      const image1 = data.desktop1.childImageSharp.fluid
      const image2 = data.desktop2.childImageSharp.fluid
      const image3 = data.desktop3.childImageSharp.fluid
      const image4 = data.desktop4.childImageSharp.fluid
      const imagesArray = [image1, image3, image4]    
      const imageData = imagesArray[Math.floor(Math.random() * imagesArray.length)];

      return (
          <BackgroundImage
            fluid={imageData}
            backgroundColor={`#000`}
            className={className}>
            <Container>
              {children}
            </Container>
          </BackgroundImage>
      )
    }}
  />
)

const Container = styled.div`
  width: 100%;
  background-position: bottom center;
  background-repeat: repeat-y;
  background-size: cover;
  background: linear-gradient(0deg, rgba(241,241,241,0) 30%, rgba(0,0,0,0.4023984593837535) 100%);
  min-height: 100vh !important;
  padding: 8px 16px 40px 16px;
  position: relative;
`

export default ContainerElement